<script setup lang="ts">
import SettingSecurityView from '../../views/SettingSecurityView/SettingSecurityView.vue';
import { styleFn } from 'shared/composables/usePage';
</script>

<template>
  <q-page
    padding
    :style-fn="styleFn"
    class="column"
  >
    <div class="col fit">
      <setting-security-view />
    </div>
  </q-page>
</template>
